import styled from '@emotion/styled'
import { WebLink } from '@news-mono/web-common'
import { breakpoint } from '../../../__styling/style-functions'

export const StyledLogoWrapLink = styled(WebLink)(() => ({
    display: 'block',
    width: '100%',
    maxWidth: 610,
    flex: 5,

    [breakpoint('sm')]: {
        flex: 2,
    },
}))
export const StyledOlympicLogoWrapLink = styled(WebLink)(() => ({
    display: 'block',
    width: '100%',
    maxWidth: 'none',
    flex: 35,

    [breakpoint('sm')]: {
        flex: 2,
    },
}))
StyledOlympicLogoWrapLink
export const StyledOlympicLogoRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
})
